import React from "react";
import RefreshIcon from "./RefreshIcon";
import { useQuery } from "@apollo/client";
import { notificationActivityClickOfUser } from "../../../Utils/AllPagesQuriesAndMutations";
import { LoadTable } from "../../Components";

const NotificationActivity = () => {
  const { data, error, loading, refetch } = useQuery(notificationActivityClickOfUser, {
    context: { headers: { "X-GraphQL-Server": "secondary" } },
    notifyOnNetworkStatusChange: true,
  });

  return (
    <div>
      <div className="title_With_Loading_Logo">
        <div className="load-post-title">Notification activity by users</div>
        <div className="load-post-logo">
          <RefreshIcon handleRefetch={refetch} loading={loading} />
        </div>
      </div>
      <div className="Page_Activity_Of_Accounts_Box">
        <LoadTable
          data={data?.getNotificationClickOfUser}
          loading={loading}
          error={error}
          title={"Notification_Activity"}
          settings={false}
          options={false}
          select={false}
        />
      </div>
    </div>
  );
};

export default NotificationActivity;
